function makeCacheKey(endpoint, data) {
  return `syos-cached-api::${endpoint}${
    Object.entries(data).reduce((previous, current) => `${previous}::${current[0]}:${current[1]}`, '')
  }`;
}

function getCachedData(key) {
  const store = window.localStorage;

  if (store) {
    const string = store.getItem(key);
    if (string) {
      return JSON.parse(string);
    }
  }

  return null;
}

function cacheData(key, data) {
  const store = window.localStorage;

  if (store) {
    try {
      store.setItem(key, JSON.stringify(data));
    } catch (exception) {
      console.log(exception);
    }
  }
}

export {
  makeCacheKey,
  getCachedData,
  cacheData,
};
